import { Fragment } from 'react';
import type { TFunction } from 'i18next';
import { RS_WEEKDAY_I18N_KEYS } from '../../utils/reservationBoardCalendar.util';
import styles from './ReservationBoardCalendar.module.css';

type RsCalendarDayRowProps = {
  day: number;
  weekday: number;
  holidayName?: string;
  todayClass: string;
  isSelectedDay: boolean;
  selectedResourceNames: string[];
  resourceNames: string[];
  isBoardOwner: boolean;
  pickHint: string;
  onPickSlot?: (day: number, resourceName?: string) => void;
  t: TFunction;
};

/** 1日分の日付・曜日・空きマス（クリックでフォームへ） */
export default function RsCalendarDayRow({
  day,
  weekday,
  holidayName,
  todayClass,
  isSelectedDay,
  selectedResourceNames,
  resourceNames,
  isBoardOwner,
  pickHint,
  onPickSlot,
  t,
}: RsCalendarDayRowProps) {
  const daySelectedClass = isSelectedDay ? styles.dayCellSelected : '';
  const dayCellTitle = [holidayName, onPickSlot ? pickHint : undefined].filter(Boolean).join(' — ');

  return (
    <Fragment>
      <button
        type="button"
        tabIndex={-1}
        data-rs-day={day}
        className={`${styles.dayCell} ${styles.dayCellButton} ${todayClass} ${daySelectedClass}`}
        style={{ gridRow: day, gridColumn: 1 }}
        title={dayCellTitle}
        onClick={() => onPickSlot?.(day)}
      >
        {day}
      </button>
      <button
        type="button"
        tabIndex={-1}
        className={`${styles.weekdayCell} ${styles.dayCellButton} ${todayClass} ${daySelectedClass}`}
        style={{ gridRow: day, gridColumn: 2 }}
        title={dayCellTitle}
        onClick={() => onPickSlot?.(day)}
      >
        <div>
          {t(RS_WEEKDAY_I18N_KEYS[weekday], {
            defaultValue: ['日', '月', '火', '水', '木', '金', '土'][weekday],
          })}
        </div>
        {holidayName ? <div className={styles.holidayLabel}>{holidayName}</div> : null}
      </button>
      {resourceNames.map((resource, resourceIndex) => {
        const resourceSelectedClass =
          isSelectedDay && selectedResourceNames.includes(resource) ? styles.dayCellSelected : '';
        return (
          <button
            type="button"
            tabIndex={-1}
            key={`${day}-${resource}`}
            className={`${styles.resourceCell} ${styles.resourceCellBackground} ${styles.resourceCellPickable} ${todayClass} ${resourceSelectedClass}`}
            style={{ gridRow: day, gridColumn: resourceIndex + 3 }}
            title={onPickSlot ? `${resource} — ${pickHint}` : resource}
            aria-label={
              onPickSlot
                ? t('reservation.board.pickSlotAria', {
                    defaultValue: '{{day}}日 {{resource}} を選択',
                    day,
                    resource,
                  })
                : undefined
            }
            onClick={() => onPickSlot?.(day, resource)}
          />
        );
      })}
      {isBoardOwner ? (
        <div
          className={`${styles.headerAddCell} ${todayClass}`}
          style={{ gridRow: day, gridColumn: resourceNames.length + 3 }}
          aria-hidden
        />
      ) : null}
    </Fragment>
  );
}
